exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: Klavika Regular;\n  src: url(\"/fonts/klavika/Klavika-Regular.ttf\");\n}\n#hover-container[data-v-e8b039b4] {\n  height: 100%;\n  position: relative;\n}\n.popover.images[data-v-e8b039b4] {\n  padding: 0.2em;\n  border-radius: 5px;\n  border: 1px solid #b7b7b7;\n  position: absolute;\n  top: 50px;\n}\n.popover.images .img-fluid[data-v-e8b039b4] {\n  height: 100px;\n}", ""]);

// exports
